import { ReactNode } from 'react';

import { Assets, Container, ContainerProps, CssGrid, Flex } from '@foradevelopment/fora-ui';

import { EmployerMyPagesErrorPage } from '../../components';
import { useAppSelector } from '../../redux/hooks';

const containerStyling: Partial<ContainerProps> = {
  backgroundColor: 'white',
  paddingTop: [30, 40, 40],
  paddingLeft: [20, 80, 100],
  paddingRight: [20, 80, 100],
  paddingBottom: 80,
};

export const DashboardGridSectionWrapper = ({ children }: { children: ReactNode }) => (
  <CssGrid {...containerStyling} rowGap={60} columnGap={60} gridTemplateColumns={['1fr', '1fr', '1fr 1fr']}>
    {children}
  </CssGrid>
);

export const DashboardGridSectionContentFirst = ({ children }: { children: ReactNode }) => (
  <Container maxWidth={['100%', '100%', 378]}>{children}</Container>
);

export const DashboardGridSectionContentSecond = ({ children }: { children: ReactNode }) => (
  <Flex maxWidth={['100%', '100%', 475]} flexDirection="column" rowGap={20}>
    {children}
  </Flex>
);

export const DashboardSectionLoading = () => {
  return (
    <Flex width="100%" {...containerStyling} justifyContent="center" alignItems="center">
      <Assets.Loading width={120} color="black20" />
    </Flex>
  );
};

export const DashboardSectionError = () => {
  const thunkError = useAppSelector(state => state.error.thunkError);

  return (
    <Flex width="100%" {...containerStyling} justifyContent="center" alignItems="center" height={500}>
      <EmployerMyPagesErrorPage type={thunkError?.code} technicalError={thunkError?.message} />
    </Flex>
  );
};
